<div class="subscription-banner">

    <div class="subscription-icon">
        ⚠
    </div>

    <div class="subscription-content">

        <div class="subscription-title">
            Subscription Reminder
        </div>

        <div class="subscription-message">

            Your subscription will expire in
            <strong>{{ daysRemaining }} days</strong>.

            Please renew your subscription to
            continue using the application.

        </div>

    </div>

    <div class="subscription-actions">

        <button type="button" class="close-button" (click)="onClose()">

            ×

        </button>

    </div>

</div>